export function createDownload(src) {
    const frame = document.createElement('iframe');
    frame.className = 'download-frame';
    frame.src = src;
    document.documentElement.appendChild(frame);
    setTimeout(() => {
        frame.remove();
    }, 100000);
}
export function contentDownload(filename, content) {
    const eleLink = document.createElement('a');
    eleLink.download = filename;
    eleLink.style.display = 'none';
    // 字符内容转变成blob地址
    const blob = new Blob([content]);
    eleLink.href = URL.createObjectURL(blob);
    // 触发点击
    document.body.appendChild(eleLink);
    eleLink.click();
    // 然后移除
    document.body.removeChild(eleLink);
}
